module.exports = __webpack_public_path__ + "img/16.4eb563e0.jpg";